// export default LearnersCreating;
import { useState, useMemo } from "react";
import "./LearnersCreating.scss";
import { TimeRange, ClassroomMetrics } from "../ClassRoom/mockData";
import images from "../../../assets/Icons/Icons";
import StoriesProgress from "./StoriesProgress";
import { prettify, upperCasePerttify } from "../../../utils/formatDate";
import { SectionLoader } from "../../Loader/sectionLoader";
import NoDataScreen from "../../EmptyScreen/EmptyScreen";
import { trackEvent } from "../../../mixpanel";

/* =====================
   Reusable UI pieces
===================== */
const ProgressRow = ({ label, value, color }: any) => (
  <div className="progress-row">
    <span className="label">{upperCasePerttify(label)}</span>
    <div className="progress-track">
      <div className={`progress-fill ${color}`} style={{ width: `${value}` }} />
      <span className="value">{value}</span>
    </div>
  </div>
);

export const StatCard = ({ label, value, color }: any) => {
  const isHex = typeof color === "string" && color.startsWith("#");

  return (
    <div className="stat-tile">
      <div
        className={`stat-label ${!isHex ? color : ""}`}
        style={isHex ? { backgroundColor: color } : undefined}
      >
        {upperCasePerttify(label)}
      </div>
      <div className="stat-value-tile">{value}</div>
    </div>
  );
};

const ACTIVITY_COLORS: Record<string, string> = {
  Doodle: "#FFC047",
  Story: "#76B8F5",
  BreathingExcercise: "#76B8F5",
  quests: "#00AD5E",
  Audio: "#FF8DEA",
  "pre-limit": "#F68C2B",
  Music: "#FFC047",
  Journal: "#00AD5E",
};

export const mapActivitiesSnapshot = (
  snapshot: any,
  type?: "activities" | "mindfulness"
) => {
  if (!snapshot) return [];

  const allowedActivities = [
    "Doodle",
    "Story",
    "quests",
    "Audio",
    "ProfileQuestion",
  ];
  const allowedMindfulness = ["pre-limit", "Music", "Journal", "Corner"];

  const allowedKeys =
    type === "mindfulness" ? allowedMindfulness : allowedActivities;

  // Label transformation map
  const LABEL_MAP: Record<string, string> = {
    doodle: "Doodle",
    Story: "Tell A Story",
    quests: "Quests",
    Audio: "Audio Stories",
    "pre-limit": "Feelings Checked-In",
    Journal: "Journal Completed",
    Music: "Music Listed To",
    Corner: "Breathing Exercise",
    profileQuestions: "ProfileQuestion",
  };

  const mappedData = Object.entries(snapshot)
    .filter(([key]) => {
      const normalizedKey = key;
      const cleanedKey = normalizedKey;

      return allowedKeys.includes(cleanedKey);
    })
    .map(([key, val]: any, index) => {
      const normalizedKey = key;
      const formattedLabel = LABEL_MAP[normalizedKey] || key;
      console.log(normalizedKey, "dsfhjgskjdhfaguyef", formattedLabel);
      return {
        label: formattedLabel,
        value: val?.count ?? 0,
        color:
          ACTIVITY_COLORS[key] ||
          ["#FFC047", "#76B8F5", "#00AD5E", "#FF8DEA", "#F68C2B"][index % 5],
      };
    });

  // ✅ Add hardcoded "Profile Questing" only for activities
  // if (type === "activities") {
  //   mappedData.push({
  //     label: "Profile Questions",
  //     value: 0,
  //     color: "#F68C2B", // change if needed
  //   });
  // }

  return mappedData;
};

/* =====================
   Main Component
===================== */
const LearnersCreating = ({
  classroomData,
  name,
  isstoryProgress,
  loading,
}: {
  classroomData: any;
  name?: string;
  isstoryProgress?: boolean;
  loading?: boolean;
}) => {
  const [open, setOpen] = useState(true);
  const colors = ["yellow", "orange", "skyblue", "green"];
  const themeColors = ["purple", "pink", "blue", "green", "skyblue", "orange"];

  const activitySnapshotData = classroomData?.data?.activitiesSnapshot;
  const themeSnapshotData = classroomData?.data?.themeProgress;
  const mindfulnessSnapshotData = classroomData?.data?.mindfulnessSnapshot;

  const isMindfulnessEmpty =
    !mindfulnessSnapshotData ||
    Object.keys(mindfulnessSnapshotData).length === 0;
  const isactivityEmpty =
    !activitySnapshotData || Object.keys(activitySnapshotData).length === 0;
  const isthemeEmpty =
    !themeSnapshotData || Object.keys(themeSnapshotData).length === 0;

  return (
    <section className="learners-creating">
      <header
        onClick={() => {
          const willBeOpen = !open;
          if (willBeOpen) {
            trackEvent("SECTION_EXPANDED_TEACHER", {
              section: name
                ? `What Is Student Working On`
                : "What Are My Learners Working On",
              view: name ? "Student" : "Classroom",
            });
          }
          setOpen(willBeOpen);
        }}
        className="section-header"
      >
        <h3>
          {name
            ? `WHAT IS ${name} WORKING ON?`
            : "WHAT ARE MY LEARNERS WORKING ON?"}
        </h3>
        <img
          src={open ? images.upIocn : images.downIcon}
          width={44}
          height={44}
        />
      </header>

      {open &&
        (loading ? (
          <SectionLoader />
        ) : (
          <>


            <div className="grid three">
              {isstoryProgress ? (
                <>
                  <StoriesProgress stories={classroomData?.data?.stories} />
                </>
              ) : (
                <>
                  <div className="lcard">
                    <h5>Stories completed</h5>
                    {classroomData?.data?.stories?.filter(
                        (item: any) =>
                          item.name?.toLowerCase().trim() !== "on boarding" &&
                          item.name?.toLowerCase().trim() !== "onboarding"
                      ).length > 0 ? (
                      classroomData?.data?.stories
                        ?.filter(
                          (item: any) =>
                            item.name?.toLowerCase().trim() !== "on boarding" &&
                            item.name?.toLowerCase().trim() !== "onboarding"
                        )
                        .map((item: any, index: number) => (
                          <ProgressRow
                            key={item.name}
                            label={item.name}
                            value={item.completionRate}
                            color={colors[index % colors?.length]}
                          />
                        ))
                    ) : (
                      <NoDataScreen />
                    )}
                  </div>
                </>
              )}
              {isstoryProgress && (
                <div className="lcard">
                  <h5 style={{textAlign:'left'}}>Theme-wise stories completed</h5>
                  {!isthemeEmpty ? (
                    classroomData?.data?.themeProgress?.map(
                      (item: any, index: number) => (
                        <ProgressRow
                          key={item.theme}
                          label={item.theme}
                          value={item.percentage}
                          color={themeColors[index % colors?.length]}
                        />
                      )
                    )
                  ) : (
                    <NoDataScreen />
                  )}
                </div>
              )}
            </div>

            {/* ================= ACTIVITIES SNAPSHOT ================= */}
            <h4 className="sub-title"></h4>

            <div className="grid three">
              {/* {!name && (
              <div className="card">
                <h5>Engagement hotspots</h5>
                {d.engagementHotspots.map((item) => (
                  <ProgressRow key={item.label} {...item} />
                ))}
              </div>
            )} */}

              <div className="card">
                <h5>Activities completed</h5>
                <div className="stats-grid">
                  {!isactivityEmpty ? (
                    mapActivitiesSnapshot(
                      classroomData?.data?.activitiesSnapshot,
                      "activities"
                    )?.map((item: any) => (
                      <StatCard key={item.label} {...item} />
                    ))
                  ) : (
                    <NoDataScreen />
                  )}
                </div>
              </div>

              <div className="card">
                <h5>Mindfulness snapshot</h5>
                <div className="stats-grid">
                  {!isMindfulnessEmpty ? (
                    mapActivitiesSnapshot(
                      classroomData?.data?.mindfulnessSnapshot,
                      "mindfulness"
                    )?.map((item) => <StatCard key={item.label} {...item} />)
                  ) : (
                    <NoDataScreen />
                  )}
                </div>
              </div>
            </div>
          </>
        ))}
    </section>
  );
};

export default LearnersCreating;
